
import CountDown from '@/components/count-down/count-down.vue'
export default {
    props:{
        backgroundColor:{  //背景颜色
            type:String,
            default:'#333333',
        },
        timestamp:{  //毫秒时间
            type: Number,
        },
        doesList:{  //倒计时列表
          type:Array,
          default:()=>{
            return []
          }
        },
        havebegun:{  //倒计时开始时间
          type:Boolean
        },
        openDown:{  //是否显示毫秒
          type:Boolean,
          default:false
        }
    },
   setup(props:any){  
     
       return {                
       }
   }
}
